// extracted by mini-css-extract-plugin
export var divider = "_2l-0";
export var dividerText = "_2l-1";